var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Attention-Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attention-Line"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0675,14.7120833 L2.92541667,14.7120833 C2.75645816,14.7125585 2.59034627,14.6685877 2.44375,14.5845833 C2.14466736,14.4152916 1.95842406,14.0994878 1.955,13.7558333 C1.96658969,13.5827602 2.02538546,13.4161722 2.125,13.2741667 L7.64291667,2.83333333 C7.72860513,2.67701168 7.85299252,2.5453074 8.00416667,2.45083333 C8.31282891,2.26190373 8.70133776,2.26190373 9.01,2.45083333 C9.16288368,2.54320411 9.287759,2.67542503 9.37125,2.83333333 L14.9316667,13.2954167 C15.0081335,13.4443369 15.0470403,13.6096909 15.0450763,13.7770833 C15.0372098,13.9466969 14.9886127,14.1119273 14.9033333,14.25875 C14.8149515,14.4012778 14.6934507,14.5203486 14.5491667,14.6058333 C14.4005524,14.6824502 14.2345556,14.7190672 14.0675,14.7120833 Z M8.5,2.93958333 C8.44236758,2.94202337 8.38630349,2.95908636 8.33708333,2.98916667 C8.28648553,3.0204053 8.2449654,3.0643678 8.21666667,3.11666667 L2.635,13.57875 C2.60680494,13.6283943 2.59214896,13.6845755 2.59242633,13.7416667 C2.59124651,13.7966345 2.60601334,13.8507795 2.635,13.8975 C2.66576763,13.9460279 2.70688881,13.987149 2.75541667,14.0179167 C2.8063446,14.0428061 2.86173695,14.0572563 2.91833333,14.0604167 L14.0320833,14.0604167 C14.0886797,14.0572563 14.1440721,14.0428061 14.195,14.0179167 C14.2451038,13.9891621 14.2866621,13.9476038 14.3154167,13.8975 C14.3444033,13.8507795 14.3591702,13.7966345 14.3579903,13.7416667 C14.3582677,13.6845755 14.3436117,13.6283943 14.3154167,13.57875 L8.755,3.11666667 C8.73120674,3.06534924 8.69144924,3.02310689 8.64166667,2.99625 C8.59972835,2.96617079 8.55111341,2.94672481 8.5,2.93958333 Z",
    id: "Shape",
    fill: "#F54F4F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10.7879167 C8.41535163,10.7878304 8.33405933,10.7548054 8.27333333,10.6958333 C8.2106955,10.6340771 8.17504387,10.5500411 8.17416667,10.4620833 L8.17416667,7.84833333 C8.17342214,7.76004517 8.2093309,7.67540309 8.27333333,7.61458333 C8.33218765,7.55280405 8.41473529,7.51926907 8.5,7.5225 C8.58753627,7.51813355 8.67271109,7.55168726 8.73375,7.61458333 C8.79775243,7.67540309 8.83366119,7.76004517 8.83291667,7.84833333 L8.83291667,10.4620833 C8.83293738,10.5497411 8.79763798,10.6337099 8.73499172,10.6950232 C8.67234546,10.7563366 8.58763704,10.7898223 8.5,10.7879167 L8.5,10.7879167 Z",
    id: "Path",
    fill: "#F54F4F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,12.75 C8.76770707,12.7528634 9.01052024,12.5934233 9.11429445,12.3466315 C9.21806865,12.0998397 9.16216056,11.8147894 8.97285225,11.6254811 C8.78354394,11.4361728 8.49849362,11.3802647 8.25170183,11.4840389 C8.00491004,11.5878131 7.84546991,11.8306263 7.84833333,12.0983333 C7.85216581,12.4566394 8.14169391,12.7461675 8.5,12.75 L8.5,12.75 Z",
    id: "Path",
    fill: "#F54F4F",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/Declined.b879c130569731f37201b19d6959a123.svg";
export { ForwardRef as ReactComponent };